module.exports = __webpack_public_path__ + "static/media/1.b916289f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/1.svg
// module id = 2801
// module chunks = 3